import React from 'react';
import "./Projects.css";
import Amazon from "./Amazon";
import Instagram from "./Instagram";
import Omnifood from './Omnifood';
import Netflix from './Netflix';
import Covid from "./Covid.js"

function Projects() {
  return (
    <div className='projects' id="projects">
    <h1>MY PERSONAL PROJECTS</h1>
    <div className='projects__alignTop'>
    <Amazon className="individualProject" />
    <Covid className="individualProject"/>

    
    </div>
    <div className='projects__alignBottom'> 
      <Netflix className="individualProject" />
      <Instagram className="individualProject" />
      <Omnifood className="individualProject" />
    </div>
    </div>
  )
}

export default Projects;